import _                              from 'underscore';
import React, { useState, useEffect } from 'react';
import { Checkbox, List }             from 'semantic-ui-react';

import { runIfFunction }                     from '../../../../../../../util';
import { BudgetCostTypesByProjectCostTypes } from '../../../../../../../services/ChartingService';

interface CompareProjectCostTypesToolOptionsProps<T = never> {
	initialValue?: BudgetCostTypesByProjectCostTypes[],
	onChange: ( data: CompareProjectCostTypesToolOptionsData ) => void,
	termDictionary?: null,
	
}

interface CompareProjectCostTypesToolOptionsData<T = never> {
	costTypes: string
}

const compareProjectCostTypesToolDefaultOptions = [
	BudgetCostTypesByProjectCostTypes.CUSTOM_COSTS,
	BudgetCostTypesByProjectCostTypes.HIRE_COSTS,
	BudgetCostTypesByProjectCostTypes.ACTIVITY_COSTS
]

function CompareProjectCostTypesToolOptions<T>(
	{
		onChange = null,
		initialValue = compareProjectCostTypesToolDefaultOptions,
	}: CompareProjectCostTypesToolOptionsProps<T> ){
	
	const [ costType, setCostType ] = useState<BudgetCostTypesByProjectCostTypes[]>( initialValue );
	
	useEffect( () => {
		
		runIfFunction( onChange, costType );
		
	}, [ costType ] );
	
	const costTypesMap = new Map( [
		[ BudgetCostTypesByProjectCostTypes.ACTIVITY_COSTS, 'Activity Costs' ],
		[ BudgetCostTypesByProjectCostTypes.HIRE_COSTS, 'Hiring Costs' ],
		[ BudgetCostTypesByProjectCostTypes.CUSTOM_COSTS, 'Custom Costs' ],
	
	] )
	
	const handleOnChanged = ( e, data ) => {
		
		const checked = data.checked;
		const value   = data.value;
		
		setCostType( prevState => {
			
			return ( checked )
			       ? [ ...prevState, value ]
			       : _.without<BudgetCostTypesByProjectCostTypes[]>( prevState, value )
		} )
		
	}
	
	return (
		<>
			<h5>Cost Types</h5>
			
			<List relaxed divided>
				{ Array.from( costTypesMap ).map( ( ( [ type, label ] ) => {
					return (
						<List.Item key={ type }>
							
							<Checkbox defaultChecked={ true } label={ label } value={ type } onChange={ handleOnChanged }/>
						
						</List.Item>
					)
					
				} ) ) }
			</List>
		</>
	);
}

export {
	CompareProjectCostTypesToolOptions,
	compareProjectCostTypesToolDefaultOptions
};
